import React from "react";
import styles from "../Dashboard.module.css";

const Membership = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Membership</main>
    </div>
  );
};

export default Membership;
